import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import EventsWarning, { MAX_EVENTS } from "./EventsWarning";
import { Tooltip } from "reactstrap";

function StepAnalysisType({ next, back }) {
  const {
    register,
    watch,
    formState: { errors, isSubmitted },
  } = useFormContext();
  const selectedType = watch("analysis_type");
  const totalEvents = watch("total_events") ?? 0;
  const isCopy = watch("IsCopy");

  const [copyWarningTooltipOpen, setCopyWarningTooltipOpen] = useState(false);

  const toggleCopyWarningTooltip = () =>
    setCopyWarningTooltipOpen((prev) => !prev);

  return (
    <div className="card bg-secondary shadow">
      <div className="card-header bg-white border-0">
        <div className="row align-items-center">
          <div className="col-8">
            <h3 className="mb-0">Tipo de análise</h3>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <label className="form-control-label">
            Tipo de Análise
            {isCopy && (
              <i
                className="fas fa-exclamation-triangle text-warning ml-2"
                id="copyWarningAnalysisType"
                style={{ cursor: "pointer" }}
              />
            )}
            {isCopy && (
              <Tooltip
                placement="right"
                isOpen={copyWarningTooltipOpen}
                target="copyWarningAnalysisType"
                toggle={toggleCopyWarningTooltip}
              >
                <div>
                  <strong>⚠️ Cópia de Pipeline</strong>
                  <br />
                  Esta é uma cópia - se alterar o tipo de análise,
                  <br />
                  algumas configurações podem não estar preenchidas no próximo
                  passo.
                </div>
              </Tooltip>
            )}
          </label>
          <div className="form-check">
            <input
              type="radio"
              value="generative"
              {...register("analysis_type", {
                required: "Por favor selecione o tipo de análise.",
              })}
              defaultChecked={selectedType === "generative"}
              className="form-check-input"
              id="analysis-generative"
              disabled={totalEvents > MAX_EVENTS ? true : false}
            />
            <label htmlFor="analysis-generative" className="form-check-label">
              Análise Generativa
            </label>
          </div>
          <div className="form-check">
            <input
              type="radio"
              value="library-matching"
              {...register("analysis_type", {
                required: "Por favor selecione o tipo de análise.",
              })}
              defaultChecked={selectedType === "library-matching"}
              className="form-check-input"
              id="analysis-library"
            />
            <label htmlFor="analysis-library" className="form-check-label">
              Enquadramento de Biblioteca
            </label>
          </div>
          {isSubmitted && errors.analysis_type && (
            <small className="text-danger" style={{ fontSize: "0.85em" }}>
              {errors.analysis_type.message}
            </small>
          )}
        </div>
        {totalEvents > MAX_EVENTS ? <EventsWarning /> : ""}

        <div className="d-flex justify-content-between mt-3">
          <button type="button" className="btn btn-secondary" onClick={back}>
            Voltar
          </button>
          <button type="button" className="btn btn-success" onClick={next}>
            Próximo
          </button>
        </div>
      </div>
    </div>
  );
}

export default StepAnalysisType;
